/**
 * Synchronizes dynamic layout heights used by the theme.
 */
document.addEventListener('DOMContentLoaded', function() {
  function setHeaderHeight() {
    const siteHeader = document.querySelector('.site-header');
    if (siteHeader) {
      const headerHeight = siteHeader.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
  }

  function setFooterHeight() {
    const footer = document.getElementById('footer');
    if (footer) {
      const footerHeight = footer.offsetHeight;
      document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
    }
  }

  // Set on page load
  setHeaderHeight();
  setFooterHeight();

  // Update on window resize
  window.addEventListener('resize', function() {
      setHeaderHeight();
      setFooterHeight();
  });
});